/** Home gallery photos — below-fold lazy load (WD-04). */
export const homeGalleryPhotos = [
  {
    src: '/Staff_Smiles.JPG',
    alt: 'DataRook staff members smiling',
    caption:
      'Our passionate team ready to inspire the next generation of data scientists',
  },
  {
    src: '/kids_at_computer.png',
    alt: 'Students working at computers',
    caption: 'Young data scientists analyzing their soccer performance',
  },
  {
    src: '/class_looks_at_heatmap_on_big_screen.png',
    alt: 'Class viewing data heatmap on screen',
    caption: 'Students discovering insights from their game data',
  },
  {
    src: '/improve_passing.JPG',
    alt: 'Student practicing passing with reaction lights',
    caption: 'Data-powered drills using rebounders with reaction lights',
  },
  {
    src: '/kids_coding.png',
    alt: 'Students coding together',
    caption: 'Learning Python while having fun with friends',
  },
  {
    src: '/teacher_helps_student_code.png',
    alt: 'Instructor helping student with coding',
    caption: 'One-on-one guidance to ensure every student succeeds',
  },
];
